import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { capturePageview } from "../lib/analytics";

/**
 * AnalyticsPageview — captures a PostHog $pageview on every SPA route change.
 * Mounted inside the Router. No-ops when analytics is disabled.
 */
export default function AnalyticsPageview() {
  const location = useLocation();
  useEffect(() => {
    capturePageview(location.pathname + location.search);
  }, [location.pathname, location.search]);
  return null;
}
